import { render, staticRenderFns } from "./AddLaundry.vue?vue&type=template&id=4663f3e6&"
import script from "./AddLaundry.vue?vue&type=script&lang=js&"
export * from "./AddLaundry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports